export const GIORNI = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
export const MESI = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

// Formatta data in YYYY-MM-DD (locale, non UTC)
export const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Prossimo giorno della settimana (1=lunedì ... 7=domenica)
export const getNextWeekday = (targetDay) => {
  const today = new Date();
  const todayDay = today.getDay();
  const todayDayMon = todayDay === 0 ? 7 : todayDay;
  let daysUntil = targetDay - todayDayMon;
  if (daysUntil <= 0) daysUntil += 7;
  const result = new Date(today);
  result.setDate(today.getDate() + daysUntil);
  return result;
};

/** Analizza il testo vocale e ricava tecnico, cliente, data, ora e luogo. */
export function parseVoiceText(text, tecnici, clienti) {
  const textLower = text.toLowerCase();

  let tecnicoTrovato = null;
  for (const t of tecnici) {
    const nomeCompleto = `${t.nome} ${t.cognome}`.toLowerCase();
    const soloNome = t.nome.toLowerCase();
    if (textLower.includes(nomeCompleto) || textLower.includes(soloNome)) {
      tecnicoTrovato = t;
      break;
    }
  }

  let clienteTrovato = null;
  for (const c of clienti) {
    const parole = c.ragione_sociale.toLowerCase().split(' ').filter(p => p.length > 3);
    for (const parola of parole) {
      if (textLower.includes(parola)) {
        clienteTrovato = c;
        break;
      }
    }
    if (clienteTrovato) break;
  }

  // Data — controllare "dopodomani" PRIMA di "domani"!
  let dataAppuntamento = new Date();
  if (textLower.includes('dopodomani')) {
    dataAppuntamento.setDate(dataAppuntamento.getDate() + 2);
  } else if (textLower.includes('domani')) {
    dataAppuntamento.setDate(dataAppuntamento.getDate() + 1);
  } else if (textLower.includes('lunedì') || textLower.includes('lunedi')) {
    dataAppuntamento = getNextWeekday(1);
  } else if (textLower.includes('martedì') || textLower.includes('martedi')) {
    dataAppuntamento = getNextWeekday(2);
  } else if (textLower.includes('mercoledì') || textLower.includes('mercoledi')) {
    dataAppuntamento = getNextWeekday(3);
  } else if (textLower.includes('giovedì') || textLower.includes('giovedi')) {
    dataAppuntamento = getNextWeekday(4);
  } else if (textLower.includes('venerdì') || textLower.includes('venerdi')) {
    dataAppuntamento = getNextWeekday(5);
  } else if (textLower.includes('sabato')) {
    dataAppuntamento = getNextWeekday(6);
  }

  // Data esplicita (es: "15 marzo")
  const matchGiornoMese = textLower.match(/(\d{1,2})\s*(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/);
  if (matchGiornoMese) {
    const giorno = parseInt(matchGiornoMese[1]);
    const mesi = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
    const mese = mesi.indexOf(matchGiornoMese[2]);
    if (mese >= 0) {
      dataAppuntamento = new Date(dataAppuntamento.getFullYear(), mese, giorno);
    }
  }

  // Ora — più formati
  let ora = '09:00';
  let matchOra = null;
  const matchEMezza = textLower.match(/(?:alle|ore)?\s*(\d{1,2})\s*e\s*mezza/);
  if (matchEMezza) {
    matchOra = [null, matchEMezza[1], '30'];
  }
  if (!matchOra) {
    const matchE = textLower.match(/(?:alle|ore)?\s*(\d{1,2})\s*e\s*(\d{1,2})/);
    if (matchE) {
      matchOra = [null, matchE[1], matchE[2].padStart(2, '0')];
    }
  }
  if (!matchOra) {
    matchOra = textLower.match(/(?:alle|ore|alle ore)\s*(\d{1,2})(?:[:\.](\d{2}))?/);
  }
  if (!matchOra) {
    matchOra = textLower.match(/\b(\d{1,2})[:\.](\d{2})\b/);
  }
  if (matchOra) {
    ora = `${matchOra[1].padStart(2, '0')}:${matchOra[2] || '00'}`;
  } else if (textLower.includes('mattina')) {
    ora = '09:00';
  } else if (textLower.includes('pomeriggio')) {
    ora = '15:00';
  } else if (textLower.includes('sera')) {
    ora = '18:00';
  }

  // Indirizzo dal cliente
  let luogo = '';
  if (clienteTrovato?.indirizzo_legale) {
    luogo = clienteTrovato.indirizzo_legale;
    if (clienteTrovato.cap_legale) luogo += `, ${clienteTrovato.cap_legale}`;
    if (clienteTrovato.citta_legale) luogo += ` ${clienteTrovato.citta_legale}`;
  }

  // Ora fine = 1 ora dopo
  const [oraH, oraM] = ora.split(':').map(Number);
  const oraFine = `${String(oraH + 1).padStart(2, '0')}:${String(oraM).padStart(2, '0')}`;

  return {
    testoOriginale: text,
    titolo: clienteTrovato ? `Appuntamento ${clienteTrovato.ragione_sociale}` : 'Nuovo appuntamento',
    data: formatDateLocal(dataAppuntamento),
    ora_inizio: ora,
    ora_fine: oraFine,
    tecnico: tecnicoTrovato,
    cliente: clienteTrovato,
    luogo,
  };
}
